import React from "react";
import { PersistGate } from "redux-persist/integration/react";
import "./App.css";
import RouteNavigator from "./routes";
import { Provider, useSelector } from "react-redux";
import { store, persistor, dispatchExceptionLogs } from "./store";
import EventEmitter from './util/event-emitter';
import SocketContextComponent from './context-api/SocketContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CubbyContextProvider from "./context-api/CubbyContext/CubbyContextProvider";
import { ThemeProvider } from "@material-ui/styles";
import { createTheme } from '@material-ui/core/styles';

class ErrorBoundary extends React.Component {

  componentDidCatch(error, info) {
    if (window.ReactNativeWebView) {
      EventEmitter.sendException({
        message: error.message,
        stackTrace: info.componentStack.toString()
      });
    } else {
      dispatchExceptionLogs(error.message, info.componentStack.toString());
    }
  }

  render() {
    return this.props.children;
  }
}

const AppComponent = () => {
  const { themeObject } = useSelector(state => state.theme);

  return (
    <ThemeProvider theme={createTheme(themeObject)}>
      <ErrorBoundary>
        <SocketContextComponent>
          <CubbyContextProvider>
            <RouteNavigator />
          </CubbyContextProvider>
        </SocketContextComponent>
        <ToastContainer
          position='top-right'
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </ErrorBoundary>
    </ThemeProvider>
  );
};

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppComponent />
      </PersistGate>
    </Provider>
  );
}

export default App;
